import React, { Fragment } from 'react';
import classNames from 'classnames';

import referralImg from "../../../assets/images/referral-image.png";
import TextInput from '../../shared/components/forms/TextInput';

const ReferralForm = ({
  name,
  contactNumber,
  onChange,
  onSubmit,
  onClose,
  errors,
  loading,
}) => {

  function submitClassName() {
    return classNames('ds-btn', '--block', {'_loading': !!loading});
  }

  return (
    <Fragment>
      <section className="_displayFlex _justifyContent-space-between _alignItems-center _padding--xlarge _padding--small-mobileOnly _backgroundColor-fcDarkBlue _borderRadiusTop">
        <div className="text">
          <h2 className="subhead -white _textAlign_left _marginBottom--none _fontSize--xxlarge-tabletUp" data-test="referral-header">Get P10,000</h2>
          <br/>
          <p className="copy -white _fontSize--small-mobileOnly _fontSize--large-tabletUp">for every business owner you successfully refer!</p>
        </div>
        <img style={{'width': '30%'}} src={referralImg} alt='referral img' />
      </section>

      <section className="cardSection _noBorder _noBottomPadding"> <p className="copy _marginBottom--large">
          Want to get P10,000? Just refer business owners within your network and we will contact them for you.
        </p>
      </section>

      <section className="cardSection">
        <label className="ds-input">
          <span>Referral's Full Name</span>
          <TextInput
            placeholder="Their Name"
            name="name"
            value={name}
            onChange={onChange}
            error={errors.name}
            dataTestId="name-input"
          />
        </label>

        <label className="ds-input">
          <span>Referral's Mobile Number</span>
          <TextInput
            placeholder="Their Mobile Number"
            name="contactNumber"
            value={contactNumber}
            onChange={onChange}
            maxLength={11}
            minLength={11}
            error={errors.contactNumber}
            dataTestId="contact-number-input"
          />
          <small>e.g 09158884441</small>
        </label>

        <button
          data-testid ="submit-button"
          className={submitClassName()}
          onClick={onSubmit}
          disabled={loading}
        >
          Submit
        </button>
        <a
          data-testid="close-button"
          style={{"fontSize": "0.98em"}}
          className="ds-btn _link _margin--large"
          onClick={onClose}
        >
          Close
        </a>
      </section>
    </Fragment>
  )
};

export default ReferralForm;



// WEBPACK FOOTER //
// ./src/features/referrals/components/Form.js